import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import ProvidersSectionContent from './Providers';
import { useGameProviders } from '@/api/game-providers';
import { ProvidersSectionProps } from './props';
import { withLazyLoad } from '@starsoft/common/hoc';

function ProvidersSection({
  isFallbacking,
}: ProvidersSectionProps): JSX.Element {
  const { gameProviders, error, refetch, isLoading } = useGameProviders();

  return (
    <ProvidersSectionContent
      data={gameProviders ?? []}
      isLoading={isLoading || Boolean(isFallbacking)}
      error={error as AxiosError<GenericError>}
      refetch={refetch}
    />
  );
}

export default withLazyLoad(ProvidersSection);
